module.exports = __webpack_public_path__ + "img/play.09946c23.jpeg";